/**
 * Chat List Selectors
 *
 * Memoized selectors for accessing the sidebar chat sessions list state.
 */
import { createSelector } from '@reduxjs/toolkit';
import type { RootState } from '@/store/store';

// ============================================
// Base Selector
// ============================================

const selectChatListState = (state: RootState) => state.chat.chatList;

// ============================================
// Memoized Selectors
// ============================================

export const selectChatListItems = createSelector(
  [selectChatListState],
  (chatList) => chatList.chats,
);

export const selectChatListIsLoading = createSelector(
  [selectChatListState],
  (chatList) => chatList.isLoading,
);

export const selectChatListIsLoadingMore = createSelector(
  [selectChatListState],
  (chatList) => chatList.isLoadingMore,
);

export const selectChatListHasMore = createSelector(
  [selectChatListState],
  (chatList) => chatList.hasMore,
);

export const selectChatListError = createSelector(
  [selectChatListState],
  (chatList) => chatList.error,
);

export const selectChatListIsLoaded = createSelector(
  [selectChatListState],
  (chatList) => chatList.isLoaded,
);
